import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default function StickyTableHorizontalScroller({ children, className, ...rest }) {
    return (
        <div
            id="sticky-table-horizontal-scroller"
            className={cx(className)}
            {...rest}>
            {children}
        </div>
    )
}

StickyTableHorizontalScroller.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string
};